import React from 'react';
import { Box, Typography } from '@mui/material';
import ViewStreamIcon from '@mui/icons-material/ViewStream';
import LinearScaleIcon from '@mui/icons-material/LinearScale';
import { REVIEW_TYPES } from '../../../constants/reviewTypes';

export const ReviewTypeBadge = ({ reviewType, getReviewTypeColor, getReviewTypeTextColor, getReviewTypeText, neutral = false }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 0.5,
        backgroundColor: neutral ? '#F3F4F6' : getReviewTypeColor(reviewType),
        color: neutral ? '#6B7280' : getReviewTypeTextColor(reviewType),
        padding: '2px 8px',
        borderRadius: '4px',
        fontSize: '12px'
      }}
    >
      {reviewType === REVIEW_TYPES.PARALLEL ? (
        <ViewStreamIcon sx={{ fontSize: 14 }} />
      ) : (
        <LinearScaleIcon sx={{ fontSize: 14 }} />
      )}
      <Typography variant="caption" sx={{ fontWeight: 500 }}>
        {getReviewTypeText(reviewType)}
      </Typography>
    </Box>
  );
}; 